
const initialState = {
    // initialValues
}

export const MidSaveToReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'INIT_QRY_FUNCTION': {
            if (action.payload && action.payload.saveTo === undefined) {
                return state;
            }
            return { saveTo: action.payload && action.payload.saveTo != null ? action.payload.saveTo : null }
        }
        case 'SET_MID_SAVE_TO': {
            let newState = Object.assign({}, state);
            newState.saveTo = action.payload;
            return Object.assign({}, state, { ...newState })
        }
        default:
        return state
    }
}